<template>
    <div>
        <el-upload
                class="upload-demo"
                ref="upload"
                :multiple="multiple"
                action="/v1/api/mg/upload"
                :show-file-list="true"
                :on-remove="handleRemove"
                :file-list="fileList"
                :on-success="handleSuccess"
                :on-preview="handlePreview"
                :auto-upload="true">
            <el-button slot="trigger" size="small" type="primary" icon="el-icon-upload" plain>Upload File</el-button>
        </el-upload>
    </div>
</template>

<script>
    import {filePath} from '@/utils/AwsUtils'
    import {s3Url} from "@/utils/Constants";

    export default {
        name: 'FileUploader',
        props: {
            uploadedFiles: {required: true, type: Array},
            multiple: {
                required: false, type: Boolean, default: () => {
                    return true
                }
            }
        },
        data() {
            return {
                prefix: s3Url,
                dialogImageUrl: '',
                dialogVisible: false,
            }
        },
        methods: {
            handleSuccess(res) {
                this.uploadedFiles.push(res)
                this.$emit('update:uploadedFiles', this.uploadedFiles)
            },
            handleRemove(file) {
                const filePath = file.url
                const files = this.uploadedFiles.filter((item) => item.path === filePath)
                this.$emit('update:uploadedFiles', files)
            },
            handlePreview(file) {
                window.open(file.url)
            }
        },
        mounted() {
            if (this.updatedFiles === undefined) {
                this.updatedFiles = []
            }
        },
        computed: {
            fileList() {
                if (this.uploadedFiles) {
                    return this.uploadedFiles.map((item) => {
                        let path = filePath(item.path)
                        return {url: path, name: item.name}
                    })

                } else {
                    return []
                }
            }
        }
    }
</script>

<style scoped>

</style>
